import api from '@/client/core/api'
import { GetCampaignMemoData, GetCampaignMemoResponse } from '@/typings/campaigns'

import { CampaignMemoApiError } from './campaignMemoApiError'

export async function getCampaignMemo(campaignId: number): Promise<GetCampaignMemoData> {
  const response = await api.get<GetCampaignMemoResponse>(`/campaigns/${campaignId}/memo`)

  if (response instanceof Error) {
    throw response
  }

  if (response?.error?.type) {
    throw new CampaignMemoApiError(response.error.type, response.error.message, response.error.status)
  }

  if (!response?.data) {
    throw new CampaignMemoApiError('INVALID_RESPONSE', 'キャンペーンメモ取得APIのレスポンス形式が不正です。')
  }

  return response.data
}
